import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { MonitoringDataService } from '../../../store/general/monitoring-data.service';
import { ReplayDataService } from './replay-data.service';
import * as HTActions from './replay.actions';

@Injectable()
export class ReplayEffects {
  getVehicleTripSummaries$ = createEffect(() =>
    this.actions$.pipe(
      ofType(HTActions.getVehicleTripSummaries),
      switchMap(action =>
        this.dataService
          .getVehicleTripSummaries(action.time_0, action.time_1, action.vehicle, action.pagination)
          .pipe(
            map(summaries => HTActions.setVehicleTripSummaries({ summaries })),
            catchError(() => of(HTActions.setVehicleTripSummariesError()))
          )
      )
    )
  );

  getCurrentTrip$ = createEffect(() =>
    this.actions$.pipe(
      ofType(HTActions.getCurrentTrip),
      switchMap(action =>
        this.dataService.getVehicleTrip(action.tripId).pipe(
          map(states => HTActions.setCurrentTrip({ states })),
          catchError(() => of(HTActions.setCurrentTripError()))
        )
      )
    )
  );

  getCurrentTripEvents$ = createEffect(() =>
    this.actions$.pipe(
      ofType(HTActions.getCurrentTripEvents),
      switchMap(action =>
        this.dataService.getVehicleTripEvents(action.tripId).pipe(
          map(events => HTActions.setCurrentTripEvents({ events })),
          catchError(() => of())
        )
      )
    )
  );

  getVehicleList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(HTActions.getVehicleTrips),
      switchMap(action =>
        this.dataService.getVehicleTrips(action.time_0, action.time_1, action.vehicle).pipe(
          map(tripsStates => HTActions.setVehicleTrips({ tripsStates })),
          catchError(() => of(HTActions.setVehicleTrips({ tripsStates: null })))
        )
      )
    )
  );

  getVehicleHistoricalAlerts$ = createEffect(() =>
    this.actions$.pipe(
      ofType(HTActions.getVehicleHistoricalAlerts),
      switchMap(action =>
        this.generalDataService.getVehicleAlerts(action.time_0, action.time_1, action.vehicle).pipe(
          map(alerts => HTActions.setVehicleHistoricalAlerts({ alerts })),
          catchError(() => of(HTActions.setVehicleHistoricalAlerts({ alerts: null })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private dataService: ReplayDataService,
    private generalDataService: MonitoringDataService
  ) {}
}
